// The two decisions the entity detail view makes per TYPE.
//
// IT IS THE ENTITY PAGE, NOT THE CUSTOMER PAGE. Six entity types shared one
// dialog, and every one of them holds assets -- a warehouse holds hundreds, a
// dealer holds some, a vendor holds none. The table is the same query with a
// different id, so building a page for customers alone would have left five
// types on the old dialog and two components doing one job. What varies per
// type is the heading and one column, and both are decided here.


// "Batteries with this customer" / "Batteries at this warehouse".
//
// WITH is custody by a person; AT is stock in a place. Using one word for both
// makes a dealer read like a customer, which is the distinction the whole
// movement model turns on.
const PLACE_TYPES = new Set(["warehouse", "vendor"]);

export const heldAssetsHeading = (entityTypeCode, entityTypeLabel, assetNoun = "Assets") => {
    // THE ORG'S OWN LABEL, lower-cased for the middle of a sentence. Deriving
    // a noun from the code would print "sub distributor" where the org calls
    // them "Channel Partners" -- the labels are config for exactly that
    // reason, and every other heading in this module already reads them.
    const noun = String(entityTypeLabel || entityTypeCode || "entity").toLowerCase();
    const preposition = PLACE_TYPES.has(String(entityTypeCode || ""))
        ? "at this"
        : "with this";
    return `${assetNoun} ${preposition} ${noun}`;
};

// The empty state's second line, which names the MECHANISM that would fill it.
//
// "No data" leaves a reader unsure whether nothing exists or nothing loaded.
// Saying what puts a row here answers both.
export const heldAssetsEmptyHint = (entityTypeCode) =>
    PLACE_TYPES.has(String(entityTypeCode || ""))
        ? "Assets appear here once a movement into this location is approved."
        : "Assets appear here once a movement to them is approved.";



